import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'resumo',
        title    : 'Resumo',
        translate: 'NAV.RESUMO',
        type     : 'item',
        icon     : 'card_travel',
        url      : '/apps/resumo'
    },
    {
        id       : 'exames',
        title    : 'Exames',
        translate: 'NAV.EXAMES',
        type     : 'item',
        icon     : 'local_hospital',
        url      : '/apps/exames'
    }/*,
    {
        id       : 'config',
        title    : 'Configurações',
        translate: 'NAV.CONFIG',
        type     : 'item',
        icon     : 'settings',
        url      : '/apps/config'
    }*/

];
